import { useEffect, useRef } from 'react';

export const Availability = ({ onSelect, onSelectAllowed, onSelectDisallowed }) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;

    isInitialized.current = true;
    onSelect?.(true);
    onSelectAllowed?.([]);
    onSelectDisallowed?.([]);
  }, [onSelect, onSelectAllowed, onSelectDisallowed]);

  return null;
};
